import moment from 'moment';

export function formatLong(date) {
  return moment(date).tz('Europe/Rome').format('DD/MM/YYYY')
}